//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2025, 2026. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//
const settings = {
  devConsole: false,
  useSocketIO: true,
  // If you need to test a teamspace task failure then use type FAIL for one of the tasks
  TEAMSPACE_TASK_SEQUENCE: [
    'TEAMSPACE NAME',
    'PLAN',
    'TEST',
    'VELOCITY',
    'CONTROL',
    'DEPLOY',
    'BUILD',
  ],
  FOCUS_FILTER_ON_LOOP_GENIE: [
    'all',
    'loop',
    'control',
    'test',
    'deploy',
    'measure',
    'plan',
    'build',
  ],
  links: {
    IBM: {
      gsg: {
        plan: 'https://www.ibm.com/docs/en/devops-plan/3.0.9?topic=overview-introduction-devops-plan',
        control:
          'https://www.ibm.com/docs/en/devops-plan/3.0.9?topic=function-devops-control',
        deploy:
          'https://www.ibm.com/docs/en/devops-loop/3.0.0?topic=deploy-getting-started',
        test: 'https://www.ibm.com/docs/en/devops-loop/3.0.0?topic=loop-test',
        velocity:
          'https://www.ibm.com/docs/en/devops-loop/3.0.0?topic=loop-measure',
        code: 'https://www.ibm.com/docs/en/devops-loop/3.0.0?topic=code-overview',
        build:
          'https://www.ibm.com/docs/en/devops-loop/3.0.0?topic=loop-build-overview',
        release:
          'https://www.ibm.com/docs/en/devops-loop/3.0.0?topic=loop-release',
      },
      ud: {
        plan: 'https://www.ibm.com/docs/en/devops-plan/3.0.9',
        control:
          'https://www.ibm.com/docs/en/devops-plan/3.0.9?topic=function-devops-control',
        deploy:
          'https://www.ibm.com/docs/en/devops-loop/3.0.0?topic=loop-deploy',
        test: 'https://www.ibm.com/docs/en/devops-loop/3.0.0?topic=loop-test',
        velocity:
          'https://www.ibm.com/docs/en/devops-loop/3.0.0?topic=loop-measure',
        code: 'https://www.ibm.com/docs/en/devops-loop/3.0.0?topic=loop-code',
        build:
          'https://www.ibm.com/docs/en/devops-loop/3.0.0?topic=loop-build-overview',
        release:
          'https://www.ibm.com/docs/en/devops-loop/3.0.0?topic=loop-release',
      },
      video: {
        plan: 'https://www.youtube.com/watch?v=WTVgvukM-A8&list=PLErYHbqUeWuAZF9G5Czq85TSlxX1PVwnq',
        control:
          'https://www.youtube.com/watch?v=WTVgvukM-A8&list=PLErYHbqUeWuAZF9G5Czq85TSlxX1PVwnq',
        deploy:
          'https://www.youtube.com/playlist?list=PLviKW0fvdXzj8-nuj2YqaBOvS0rCX2LTe',
        test: 'https://www.youtube.com/playlist?list=PLpMYWEs9L3uXUqHgt2iJJqXqcIibJZk5j',
        velocity:
          'https://www.youtube.com/watch?v=MG0sVvWaCj8&list=PLviKW0fvdXzhD57UTKshPOG6F_n9y7Y7D&index=1',
        code: '', // No video provided for code
        build: '', // No video provided for build
        teamspaceCreation:
          'https://ibm.com/docs/en/SSGB5S_3.0.0/docs/videos/creating%20a%20teamspace.mp4',
        loopCreation:
          'https://ibm.com/docs/en/SSGB5S_3.0.0/docs/videos/creating%20a%20loop.mp4',
      },
      userManual: 'https://www.ibm.com/docs/en/devops-loop/3.0.0',
      news: 'https://www.ibm.com/docs/en/devops-loop/3.0.0?topic=notes-whats-new',
      plugins: 'https://urbancode.github.io/IBM-UCx-PLUGIN-DOCS/',
      footer: {
        Facebook: 'https://community.ibm.com/community/user/my-community',
        Twitter: 'https://x.com/ibm',
        LinkedIn: 'https://www.linkedin.com/company/ibm',
        Instagram: 'https://www.instagram.com/ibm/#',
        YouTube: 'https://www.youtube.com/@IBM',
      },
    },
    HCL: {
      gsg: {
        plan: 'https://help.hcl-software.com/devops/plan/3.0.9/oxy_ex-1/com.ibm.rational.clearquest.getstart.doc/topics/c_intro_container.html',
        control:
          'https://help.hcl-software.com/devops/plan/3.0.9/oxy_ex-1/control/content/index.en-us.html',
        deploy:
          'https://help.hcl-software.com/devops/loop/3.0.0/docs/deploy.html',
        test: 'https://help.hcl-software.com/devops/loop/3.0.0/docs/topics/test.html',
        velocity:
          'https://help.hcl-software.com/devops/loop/3.0.0/docs/topics/measure.html',
        code: 'https://help.hcl-software.com/devops/loop/3.0.0/docs/code/overview.html',
        build:
          'https://help.hcl-software.com/devops/loop/3.0.0/docs/build/docs/topics/intro_ch.html',
        release:
          'https://help.hcl-software.com/devops/loop/3.0.0/docs/topics/release.html',
      },
      ud: {
        plan: 'https://help.hcl-software.com/devops/plan/3.0.9/index.html',
        control:
          'https://help.hcl-software.com/devops/plan/3.0.9/oxy_ex-1/control/content/index.en-us.html',
        deploy:
          'https://help.hcl-software.com/devops/loop/3.0.0/docs/deploy.html',
        test: 'https://help.hcl-software.com/devops/loop/3.0.0/docs/topics/test.html',
        velocity:
          'https://help.hcl-software.com/devops/loop/3.0.0/docs/topics/measure.html',
        code: 'https://help.hcl-software.com/devops/loop/3.0.0/docs/code/devops_code.html',
        build:
          'https://help.hcl-software.com/devops/loop/3.0.0/docs/build/docs/topics/loop_build_overview.html',
        release:
          'https://help.hcl-software.com/devops/loop/3.0.0/docs/topics/release.html',
      },
      video: {
        plan: 'https://www.youtube.com/watch?v=WTVgvukM-A8&list=PLErYHbqUeWuAZF9G5Czq85TSlxX1PVwnq',
        control:
          'https://www.youtube.com/watch?v=WTVgvukM-A8&list=PLErYHbqUeWuAZF9G5Czq85TSlxX1PVwnq',
        deploy:
          'https://www.youtube.com/playlist?list=PLviKW0fvdXzj8-nuj2YqaBOvS0rCX2LTe',
        test: 'https://www.youtube.com/playlist?list=PLpMYWEs9L3uXUqHgt2iJJqXqcIibJZk5j',
        velocity:
          'https://www.youtube.com/watch?v=MG0sVvWaCj8&list=PLviKW0fvdXzhD57UTKshPOG6F_n9y7Y7D&index=1',
        code: '', // No video provided for code
        build: '', // No video provided for build
        teamspaceCreation:
          'https://help.hcl-software.com/devops/loop/3.0.0/docs/videos/creating%20a%20teamspace.mp4',
        loopCreation:
          'https://help.hcl-software.com/devops/loop/3.0.0/docs/videos/creating%20a%20loop.mp4',
      },
      userManual: 'https://help.hcl-software.com/devops/loop/3.0.0/index.html',
      news: 'https://help.hcl-software.com/devops/loop/3.0.0/docs/topics/rn_whatsnew.html',
      plugins: 'https://hcl-software.com/plugins/',
      footer: {
        Facebook: 'https://www.facebook.com/HCLSW/',
        Twitter: 'https://x.com/HCLSoftware',
        LinkedIn: 'https://www.linkedin.com/company/hclsoftware/',
        Instagram: 'https://www.instagram.com/hcl_software/',
        YouTube: 'https://www.youtube.com/HCLSoftware',
      },
    },
  },
};

export default settings;
